<template>
    <div><!-- 招標案件明細 -->
        <CCard>
            <CCardBody>
               <SupplierInfo :quoteRow="quoteRow" :quoteVendorRow="quoteVendorRow" :isView="isView"/>
            </CCardBody>
        </CCard>
        <!-- 報價明細區塊 -->
        <PurchaseContent :quoteRow="quoteRow" :isView="isView" :currentVendorId="quoteVendorRow.vendorId" @confirmFile="confirmFile" />
        <submitButton :clickEvent="saveAll" v-if="!isView"/>
    </div>
</template>

<script>
import SupplierInfo from './SupplierInfo'
//import SupplierContent from './SupplierContent'
import PurchaseContent from '../Purchase/PurchaseEdit/PurchaseContent.vue';
export default {
    components: {
        SupplierInfo,
        //SupplierContent
        PurchaseContent
    },
    data() {
        return {      
            quoteRow: {vendorList: []},      
            quoteVendorRow: {vendorId: '' ,memo:'' , totalPriceWithoutTax: 0},
            confirm: false,
        }
    },
    props : {
    },
    methods: {
        saveAll() {
            const url = `${this.$apiUrl_Quotation}/VendorUpdateRequestForQuote`;
            let param = { guid: this.quoteRow.guid , memo: this.quoteVendorRow.memo};

            if(this.confirm) {
                this.$alert("報價單未上傳成功，請點選＂確認＂後再按＂儲存＂",'警告',{type: 'warning'});
            } else {
                this.updateLoading(true);
                this.axios.post(url, param).then((response) => {
                    const {status , statusMessage} = response.data;
                    this.updateLoading(false);
                    if(status){
                        this.$alert(statusMessage,'警告',{type: 'warning'});
                    }else{                    
                    //--成功存檔 
                    this.$router.push('/Manufacturer');
                    }                    
                });
            }
            // this.updateLoading(true);
            // this.axios.post(url, param).then((response) => {
            //     const {status , statusMessage} = response.data;
            //     this.updateLoading(false);
            //     if(status){
            //         this.$alert(statusMessage,'警告',{type: 'warning'});
            //     }else{                    
            //        //--成功存檔 
            //        this.$router.push('/Manufacturer');
            //     }                    
            // });
        },
        getDetail(guid) {//目前編輯的單筆採購案件
            const url = `${this.$apiUrl_Quotation}/GetRequestForQuote/${guid}`;
            this.updateLoading(true);
            this.axios.get(url).then((response) => {                
                let resp = {
                    ...response.data,
                    startDate: response.data.startDate.substring(0,10),
                    deadline: response.data.deadline.substring(0,10),
                }                
                if(resp.guid === guid){
                    this.quoteVendorRow.vendorId = resp.vendorId;
                    this.quoteVendorRow.memo = resp.memo;
                    this.quoteVendorRow.currency= resp.currency;
                    this.quoteVendorRow.totalPriceWithoutTax= resp.totalPriceWithoutTax;
                    this.quoteRow = resp;
                } else {
                    this.$alert('無此招標案件!','警告',{type: 'warning'});
                    this.$router.push('/Manufacturer');
                }
                this.updateLoading(false);
            })
        },
        confirmFile(check) {
            this.confirm = check
        }
    },
    computed: {                
        isView (){
            const item = this.quoteRow;
            if(!item) return true;           
            const today= new Date().yyyymmdd();                               
            if(item.caseClosed === 'N' && (item.deadline && item.deadline >= today)){
                return false;
            }else{
                //報價截止日期<系統當日時，供應商不得於ROE平台上進行報價，或案件已經關閉
                return true;
            }            
        }
    },
    mounted() {        
        let purchaseId = sessionStorage.getItem('purchaseId');
        this.getDetail(purchaseId);
    }
}
</script>

